// extracted by mini-css-extract-plugin
export default {"form":"MedicoFormNew_form__h8HlX","wrapper":"MedicoFormNew_wrapper__+q5pm","select":"MedicoFormNew_select__OrJk9","label":"MedicoFormNew_label__lSD5d"};